import type { BuilderNode } from "../../../types";
import { FormBuilderFieldRow } from "./form-builder-field-row";
import { FormBuilderRootSectionSortableRow } from "./form-builder-section-root-row";

export function FormBuilderRootItemRow({
	id,
	node,
	selectedId,
	onSelect,
	onMoveSection,
}: {
	id: string;
	node: BuilderNode | undefined;
	selectedId: string | null;
	onSelect: (id: string) => void;
	onMoveSection: (sectionId: string, dir: "up" | "down") => void;
}) {
	if (!node) return null;

	if (node.kind === "section") {
		return (
			<FormBuilderRootSectionSortableRow
				id={id}
				node={node}
				selectedId={selectedId}
				onSelect={onSelect}
				onMoveSection={onMoveSection}
			/>
		);
	}

	return (
		<FormBuilderFieldRow
			id={id}
			node={node}
			selectedId={selectedId}
			onSelect={onSelect}
		/>
	);
}
